
import { CoreModule } from './../../core/core.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LotesRepasseComponent } from './lotes-repasse.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { LotesRepasseRoutingModule } from './lotes-repasse-routing.module';

@NgModule({
  declarations: [LotesRepasseComponent],
  imports: [
    CommonModule,
    SharedModule,
    LotesRepasseRoutingModule,
    ReactiveFormsModule,
    CoreModule
  ]
})
export class LotesRepasseModule {}
